import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { isset } from "../../utils/Utils";

export const actionTypes = {
    LoadExperts: "[LoadExperts] Action",
    LoadChatList: "[LoadChatList] Action",
    LoadingChatList: "[LoadingChatList] Action",
    LoadSelectedChat: "[LoadSelectedChat] Action",
    LoadingSelectedChat: "[LoadingSelectedChat] Action",
    SubmittingMessage: "[SubmittingMessage] Action",
    LoadShowMobileHistory: "[LoadShowMobileHistory] Action",
};

const initialExpertsState = {
    experts: [],
    chatList: [],
    loadingChatList: false,
    selectedChat: undefined,
    loadingSelectedChat: false,
    submittingMessage: false,
    showMobileHistory: false,
};

export const reducer = persistReducer({ storage, key: "app-experts", whitelist: [] }, (state = initialExpertsState, action) => {
    switch (action.type) {
        case actionTypes.LoadExperts: {
            return {
                ...state,
                experts: action.payload,
            };
        }

        case actionTypes.LoadChatList: {
            return {
                ...state,
                chatList: action.payload,
            };
        }

        case actionTypes.LoadingChatList: {
            return {
                ...state,
                loadingChatList: isset(action.payload) ? action.payload : !state.loadingChatList,
            };
        }

        case actionTypes.LoadSelectedChat: {
            return {
                ...state,
                selectedChat: action.payload,
            };
        }

        case actionTypes.LoadingSelectedChat: {
            return {
                ...state,
                loadingSelectedChat: isset(action.payload) ? action.payload : !state.loadingSelectedChat,
            };
        }

        case actionTypes.SubmittingMessage: {
            return {
                ...state,
                submittingMessage: isset(action.payload) ? action.payload : !state.submittingMessage,
            };
        }

        case actionTypes.LoadShowMobileHistory: {
            return {
                ...state,
                showMobileHistory: isset(action.payload) ? action.payload : !state.showMobileHistory,
            };
        }

        default:
            return state;
    }
});

export const expertsActions = {
    loadExperts: (payload) => ({ type: actionTypes.LoadExperts, payload }),
    loadChatList: (payload) => ({ type: actionTypes.LoadChatList, payload }),
    loadingChatList: (payload) => ({ type: actionTypes.LoadingChatList, payload }),
    loadSelectedChat: (payload) => ({ type: actionTypes.LoadSelectedChat, payload }),
    loadingSelectedChat: (payload) => ({ type: actionTypes.LoadingSelectedChat, payload }),
    submittingMessage: (payload) => ({ type: actionTypes.SubmittingMessage, payload }),
    loadShowMobileHistory: (payload) => ({ type: actionTypes.LoadShowMobileHistory, payload }),
};

export function* saga() {}
